import AnimatedCircleProgress from "@components/AnimatedCircleProgress"
import { getStatusColors, getStatusTextColors } from "@pages/JobPage/components/ViewByJob"
import { EnumJobStatus2, JobStatus } from "@utils/constants"
import dayjs from "dayjs"
import { Check, StarIcon } from "lucide-react"
import { useState } from "react"
import { NavLink } from "react-router-dom"

const ApplicantCard = ({ data }) => {
    const isClosed = data?.status === JobStatus.CLOSED && "Closed";
    const [isMarkedFavorite, setIsMarkedFavorite] = useState(false)
    const [isMarking, setIsMarking] = useState(false)

    console.log('this is data', data)
    return (
        <NavLink
            // to={'#'}
            to={`/job-applicant-detail`}
            state={{ item: data }}
            // onClick={onClick}
            className="grid grid-cols-[1.2fr_1.4fr_0.3fr] gap-12 justify-between bg-white py-5 px-3 border-b border-[#ececec] hover:bg-slate-100 cursor-pointer"
        >
            <div className="flex flex-col gap-1">
                <div className="flex items-center justify-between">
                    <span className="text-[10px] text-light-black font-medium pl-2">
                        {data?.candidateDetails?.refNo}
                    </span>
                    <span className={`flex justify-center items-center font-medium text-[10px] ${getStatusTextColors({ status: data?.status })}`}> {data?.status === JobStatus.LIVE && "Live"}
                        {data?.status === JobStatus.DRAFT && "Draft"}
                        {data?.status === JobStatus.UNPUBLISHED && "Unpublished"}
                        {data?.status === JobStatus.CLOSED && "Closed"}
                        {data?.status === JobStatus.EXPIRED && "Expired"}
                    </span>
                </div>
                <div className={`flex gap-4 rounded-md py-3 px-5 border border-y-gray-100 border-r-gray-100 ${getStatusColors({ status: data?.status })} border-l-[3px]`}>
                    <div className="flex items-center justify-center w-[35px] h-[35px] bg-gray-100 rounded-full">
                        {
                            data?.candidateDetails?.profilePic ?
                                <img src={data?.candidateDetails?.profilePic} className="w-full h-full object-cover rounded-full" />
                                :
                                <span className="font-bold">{data?.candidateDetails?.firstName?.charAt(0)}</span>
                        }
                    </div>
                    <div className="flex flex-col gap-0.5">
                        <span className="text-xs font-bold text-charcoal line-clamp-1">{data?.candidateDetails?.firstName} {data?.candidateDetails?.lastName}</span>
                        <span className="text-xss font-medium text-light-black">{data?.jobDetails?.title || 'N/A'}</span>
                    </div>
                </div>
            </div>

            <div className="flex flex-col gap-1">
                <div className="flex items-center gap-5 h-[1rem]">
                    {
                        data?.latestTracker?.createdAt ?
                            <>
                                <span className="text-xss text-light-black font-medium italic">
                                    {dayjs(data?.latestTracker?.createdAt).format("hh:mm a")}
                                </span>
                                <span className="text-xss text-light-black font-medium italic">
                                    {dayjs(data?.latestTracker?.createdAt).format("DD MMM YYYY")}
                                </span>
                            </>
                            :
                            null
                    }
                </div>

                <div className="flex items-center bg-light-white-700 border border-gray-200 rounded-md h-[3.8rem] py-3 px-3">
                    {
                        [EnumJobStatus2.CLOSED, EnumJobStatus2.EXPIRED]?.includes(data?.jobDetails?.status) ?
                            <span className="text-xs text-charcoal font-medium">Job {EnumJobStatus2.CLOSED === data?.jobDetails?.status ? 'closed' : 'expired'} for the position titled <span className="font-bold">{data?.jobDetails?.title}</span></span>
                            :
                            <span className="text-xs font-medium text-charcoal">
                                Latest Activity : {data?.latestTracker?.status || 'N/A'}
                            </span>
                    }
                </div>
            </div>

            <div className="flex flex-col text-xss gap-2">
                Matched %
                <div className="relative">
                    <AnimatedCircleProgress
                        progress={data?.matchingPercentage || 0}
                        strokeWidth={4}
                        textStyle="font-semibold text-charcoal"
                    />
                </div>
            </div>
        </NavLink>
    );
    return <NavLink
        to={`/job-applicant-detail`}
        state={{
            item: data
        }}
        className="grid grid-cols-[1.3fr_2.5fr_0.42fr_0.42fr_0.42fr] gap-5 items-center justify-between bg-white border-b border-[#ececec] rounded px-2 py-5 hover:bg-gray-50 cursor-pointer"
    >
        <div className="flex gap-3 pt-1 h-full">
            {
                data?.candidateDetails?.profilePic ?
                    <img
                        src={data?.candidateDetails?.profilePic}
                        className="h-11 w-11 rounded-full" />
                    : <div className="flex h-11 w-11 rounded-full bg-gray-100 border">
                        <span className="font-semibold text-lg text-light-black m-auto">{data?.candidateDetails?.firstName?.charAt(0)}</span>
                    </div>
            }
            <div className="flex flex-col gap-2.5">
                <span className="font-medium text-light-black text-xs">{data?.candidateDetails?.refNo}</span>
                <span className="font-bold text-charcoal text-xs">{data?.candidateDetails?.firstName} {data?.candidateDetails?.lastName}</span>
                <span className="font-medium text-light-black text-xs">{data?.candidateDetails?.jobTitle || 'N/A'}</span>
            </div>
        </div>
        <div className="flex flex-col gap-1">
            <span className="font-medium text-xs italic text-light-black">{dayjs().format('hh:mm a DD MMM YY')}</span>
            <div className="flex flex-col justify-center border-2 rounded-md p-3 h-[3.8rem]">
                <span className="text-xs text-light-black font-medium">Applied: Joe Bloggs has applied for the job post <span className="font-bold text-charcoal">Cyber Security Manager</span></span>
            </div>
        </div>

        <div className="flex flex-col justify-end items-center h-full gap-2">
            <div className="h-[3.8rem] w-[3.8rem] rounded-full border-2 flex">
                <Check className="h-6 w-6 m-auto" stroke="gray" />
            </div>
        </div>
        <div className="flex flex-col justify-end items-center h-full gap-2">
            <AnimatedCircleProgress
                progress={20}
                size={63}
            />
        </div>
        <div className="flex flex-col justify-center items-center h-full gap-2">
            {/* <div className="h-[3.8rem] w-[3.8rem] rounded-full border-2 flex">
                <AnimatedNumber
                    value={data?.totalJobs || 0}
                    className="font-bold text-sm text-charcoal m-auto"
                />
            </div> */}
            <StarIcon size={40} className="mt-3" strokeWidth={1} stroke="gray" />
        </div>
    </NavLink>
}

export default ApplicantCard